import React, { useState, useEffect, useRef } from 'react';
// import Logo from '../../Images/logo black.png'
// import mobileLogo from '../../Images/mobile-logo.svg'
import logo from '../../assets/og logo.svg';
import { NavLink, Link, Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import AsyncStorage from '@react-native-async-storage/async-storage';
import classes from '../HeaderNav/HeaderNav.module.css';
import { Navbar, Nav, Dropdown, NavDropdown } from 'react-bootstrap';


const HeaderNav = () => {
  const navigate = useNavigate();
  const [bearer, setBearer] = useState('');
  const [loading, setLoading] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  

  const readData = async () => {
    // try {
    //   const value = await AsyncStorage.getItem('userToken');
    //   if (value !== null) {
    //     setBearer(value);
    //   }
    // } catch (e) {
    //   alert('Failed to fetch the input from storage');
    // }
  };

  useEffect(() => {
    readData();
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle the menu open/close state
  };

  const closeMenu = () => {
    setIsMenuOpen(false); // Close the menu
  };

  // const headers = {
  //   'Content-Type': 'application/json',
  //   'Authorization': `Bearer ${bearer}`
  // };

 
  return (
    <div className={classes.headerSection} >
      <nav expand="lg" className={classes.nav}>
        <div className={classes.navContainer} >
          <NavLink to={'/'} className={classes.navLogoWeb}><img src={logo}  className={classes.logoicon}/></NavLink>
          <ul className={`${classes.mainMenu} ${isMenuOpen ?  '' : classes.menuOpen}`}>
            <li className={classes.linkList}>
              <Link to={'/'} >Home</Link>
              <Link to={'/news'} >News</Link>
              <Link to={'/open_government'} >Open Government</Link>
              <Link to={'/ministry_department_agencies'} >MDAs</Link>
              {/* <NavDropdown title="Open Government" id="basic-nav-dropdown"  style={{ display:'flex', flexDirection:'column', gap:'10px'}}>
              <NavDropdown.Item as={Link} to={'/financial_statements'}>Financial Statements</NavDropdown.Item>
              <NavDropdown.Item as={Link} to={'/ministry_of_budgets_documents'}>Ministry of Budgets Documents</NavDropdown.Item>
              <NavDropdown.Item as={Link} to={'/ogstep_documents'}>Contracts & Adverts</NavDropdown.Item>
            </NavDropdown> */}
              {/* <Link to={'#'} >Archives</Link> */}
              <Link to={'/executives'} >Executives</Link>
              {/* <NavDropdown title="Legends" id="basic-nav-dropdown"  style={{ display:'flex', flexDirection:'column', gap:'10px'}}>
              <NavDropdown.Item as={Link} to={'#'}>Politics</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to={'#'}>Entertainment</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to={'#'}>Sports</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to={'#'}>Media</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to={'#'}>Academics</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to={'#'}>Business</NavDropdown.Item>
            </NavDropdown> */}
            <Link to={'/contact_us'} >Contact Us</Link>
            <Link to={'/privacy_policy'} >Privacy Policy</Link>
              {/* <Link to={'darshboard '}>Dashboard</Link> */}
            </li>
            <li className={classes.navItem}>
              {/* <NavLink to={'/login'}><button className={classes.whiteBtn}>Log In</button></NavLink> */}
              {/* <NavLink to={'/ministry_department_agencies'}><button className={classes.greenBtn}>Ogun state MDAs</button></NavLink> */}
            </li>
          </ul>
          <div className={classes.harmborgers} onClick={toggleMenu}>
            {isMenuOpen ? (
              <span className={classes.closs}>
                <i className='bx bx-x'></i>

              </span>
            ) : (
              <span className={classes.open}>
                <i className='bx bx-menu'></i>
              </span>
            )}
          </div>
        </div>
      </nav>
    </div>
    //   </div>
    // </div>
  );
};

export default HeaderNav;